export const envMapper = ({ base }) => {
  return (
    base[window.env?.SLLR_BASE_API_URL] ||
    base[`${window.env?.SLLR_BASE_API_URL}/`]
  );
};

export const smartUrlRedirection = ({ base, extraURLData = '', maskedURL }) => {
  const env = envMapper({
    base,
    maskedURL
  });
  return `https://${env}/${extraURLData}`;
};
